<template>
    <div class="IpcViewerComponent">
        
        <div class="element-probing">
            <b-list-group>
                <b-list-group-item>&nbsp; {{tooltipObject.text}}</b-list-group-item>
                               
        
            </b-list-group>
        </div>
        <div class="svgContainer">
            
            <div :id="'svgPCB_' + name" class="svgPCB"></div>
        </div>
        <div v-if="layers.length > 0" class="element-layers">
            <b-list-group>
                <b-list-group-item>{{lang.infotext_1}}: 
                    <br>
                    <b-form-checkbox-group 
                    class="layers-checkboxes"
                    v-model="selectedLayers" 
                    :options="layers" 
                    stacked
                    ></b-form-checkbox-group>


                </b-list-group-item>
        
        
            </b-list-group>
        </div><br><br>
        
    </div>
</template>

<script>
//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'

import panzoom from "panzoom";
//import { mapGetters } from "vuex";
export default {
    name: "IpcViewerComponent",
    data() {
        return {
            id: "IpcViewerComponent",
            svgData: "",
            currentPropElement: {},
            allCrossElement: [],
            allSelectedElement: [],
            allChangedSelectedElement: [],
            allCrossElementOld: [],
            allSelectedColors: [],
            
            oldBomId: null,
            tooltipObject: {
                show: false,
                text: ""
            },
            configParts: [],
            layers: [],
            selectedLayers: [],
            svgViewboxAdjusted:"notok"
        };
    },
    props: {
        name: String,
        zooming: Boolean,
        lang: Object,
    },
    computed: {
        // ...mapGetters({
        //     selectedPartBomRow: 'selectedPartBomRow',

        // }),
        _part_reference() {
            const arr = [];
            
            if (this.name == "Parts") {
                
                if (this.$store.getters.selectedPartBomRow.libraries == true) {
                    let rf = "";
                    if (this.$store.getters.selectedPartBomRow.partReference != undefined) {
                        rf = this.$store.getters.selectedPartBomRow.partReference;
                    } 
                    if (rf != null) {
                        let temp = rf.split(" ");


                        for (let i = 0, lei = temp.length; i < lei; i++) {
                            arr.push(temp[i]);
                        }
                    }
                    
                    return arr;
                }
                if (this.$store.getters.selectedPartBomRow.partId != undefined) {
                    let rf = "";
                    if (this.$store.getters.selectedPartBomRow.PartReference != undefined) {
                        rf = this.$store.getters.selectedPartBomRow.PartReference;
                    } else {
                        rf = this.$store.getters.selectedPartBomRow.PartReference;
                    }
                    
                    if (rf != null) {
                        let temp = rf.split(" ");


                        for (let i = 0, lei = temp.length; i < lei; i++) {
                            arr.push(temp[i]);
                        }
                    }

                }
            }
            if (this.name == "ProjectTable") {

                arr.push(this.$store.getters.selectedPartBomRow.partReference);
            }
            if (this.name == "CompareVariants") {

                arr.push(this.$store.getters.selectedPartBomRow.partReference);
            }
            
            return arr;
        },
        checkboxVariant() {
            return this.$store.getters.checkboxVariant;
        },
        reloadedAfterAction() {
            return this.$store.getters.reloadedAfterAction;
        },
        revisionId() {
                        
            if (this.$route.path == "/ProjectManager/ProjectImportIPC") {
                
                return this.$route.query.revisionId;
            }
            if (this.$route.path == "/ProjectManager/ProjectBom") {

                return this.$route.query.currentRevisionId;
            }
            if (this.$route.path == "/ProjectManager/ProjectDetails") {
                if (this.$store.getters.selectedRevisionRow.length == 0) {
                    return null;
                }
                return this.$store.getters.selectedRevisionRow[0].revisionId;
            }
            if (this.$route.query.revisionId != undefined) {
                return this.$route.query.revisionId;
            }
            
            if (this.$store.getters.selectedRevisionRow.length == 0) {
                return null;
            }
            
            return this.$store.getters.selectedRevisionRow[0].revisionId;
        },
        
    },
    created() {

        this.getSVG();
    },
    watch: {
        reloadedAfterAction: function (newValue) {
            
            if (newValue.name == this.id) {
                if (newValue.status == true) {

                    this.getSVG();

                    newValue.status = false;
                    newValue.name = "";
                    this.$store.dispatch("reloadAfterAction", newValue);
                }
            }
        },
        
        revisionId: {
            handler: function (newVal) {
                
                this.getSVG();
            },
            deep: true


        },
        _part_reference: function (_newValue, _oldValue) {
            
                        
            this.unSelectAllParts();
            if (_newValue != "") {
            
                this.selectPart(_newValue, "#00cc00");
            }

            
        },
        fileData: function (newVal) {
            if (newVal) {
                this.loadSVG(this.fileData);
            }
        },
        checkboxVariant: function (_newValue, _oldValue) {
            this.resetAllVariants();

            this.allCrossElement = [];
            this.allSelectedElement = [];
            this.allChangedSelectedElement = [];
            let obj = {};
            this.allSelectedColors = [];
            

            if (_newValue != null) {

                
                
                for (let i = 0, lei = _newValue.variantParts.length; i < lei; i++){
                    
                    if (_newValue.variantParts[i] !== undefined) {
                        if (_newValue.variantParts[i].partNumber.toLowerCase() == "dni" || _newValue.variantParts[i].partNumber == "") {
                            this.allCrossElement.push(_newValue.variantParts[i].partReference);
                            obj = {
                                partReference: _newValue.variantParts[i].partReference,
                                color: "#FF2200",
                                partNumber: _newValue.variantParts[i].partNumber
                            }
                            this.allSelectedColors.push(obj)
                        }

                        for (let j = 0, lej = _newValue.core.length; j < lej; j++) {
                            if (_newValue.variantParts[i].partReference == _newValue.core[j].partReference) {
                                
                                if (_newValue.variantParts[i].partNumber == _newValue.core[j].partNumber ) {
                                    this.allSelectedElement.push(_newValue.variantParts[i].partReference);
                                    obj = {
                                        partReference: _newValue.variantParts[i].partReference,
                                        color: "#0f0",
                                        partNumber: _newValue.variantParts[i].partNumber
                                    }
                                    this.allSelectedColors.push(obj)
                                } else {
                                    this.allChangedSelectedElement.push(_newValue.variantParts[i].partReference);
                                    if (_newValue.variantParts[i].partNumber.toLowerCase() != "dni") {
                                        
                                        obj = {
                                            partReference: _newValue.variantParts[i].partReference,
                                            color: "#FFA500",
                                            partNumber: _newValue.variantParts[i].partNumber
                                        }
                                        this.allSelectedColors.push(obj)
                                    }
                                    
                                }
                            }
                        }

                        
                        
                    }
                    
                }
                    
                               
                this.selectPartVariants(this.allChangedSelectedElement, "#FFA500");
                this.selectPartVariants(this.allSelectedElement, "#00FF00");
                let vue = this;
                
                this.$nextTick(function () {
                    vue.crossPartVariants(vue.allCrossElement, "#FF2200");
                    vue.unSelectAllParts();
                    
                    vue.selectPart(vue._part_reference, "#00cc00");
                })
                
                
            } else {
                
                this.resetAllVariants();
                
            }
        },
        selectedLayers: function (_newValue, _oldValue) {
            
            
            let base = document.getElementById("svgPCB_" + this.name);
            const layers = base.querySelectorAll('[class="layer"]')
            for (let i = 0, lei = layers.length; i < lei; i++) {
                
                if (!_newValue.includes(layers[i].id)) {
                    
                    layers[i].style.display = "none";
                } else {
                    layers[i].style.display = "block";
                }
            }
        }
    },
    methods: {
        addEventsToParts() {
            let vue = this;
            let base = document.getElementById("svgPCB_" + this.name);
            const parts = base.querySelectorAll('[id*="svg__"]')

            

            for (let i = 0, lei = parts.length; i < lei; i++){

                
                const style = window.getComputedStyle(parts[i], null);

                //parts[i].style.stroke = "#E87C1E";
                parts[i].style.fill = "#0f0";
                parts[i].style["fill-opacity"] = "0.0";
                parts[i].addEventListener("mouseover", function (e) {

                    let temp = this.id.split("__");
                   
                    vue.tooltipObject.text = temp[1];
                })
                parts[i].addEventListener("mouseout", function (e) {
                    
                    vue.tooltipObject.text = "";
                })
                
                let temp = parts[i].id.split("__");
                let obj = {
                    partReference: temp[1],
                    stroke: parts[i].style.stroke,
                    strokeWidth: parts[i].style.strokeWidth
                }
                
                this.configParts[temp[1]] = obj;
                
            }
            this.getLayers();
        },
        getLayers() {

            let base = document.getElementById("svgPCB_" + this.name);
            const layers = base.querySelectorAll('[class="layer"]')
            this.layers = [];
            for (let i = 0, lei = layers.length; i < lei; i++) {
                

                let temp = layers[i].id;

                const obj = {
                    text: layers[i].id,
                    value: layers[i].id
                }
                this.layers.push(obj);
                this.selectedLayers.push(layers[i].id);
            }

            const temps = base.querySelectorAll('[class="cls-ipc"]')

            if (temps.length > 0) {
                
                this.$store.dispatch(this.$store.getters.sectionPrefix + "_noIpcImage", true);
            } else {
                this.$store.dispatch(this.$store.getters.sectionPrefix + "_noIpcImage", false);
            }
            
        },
        getSVG() {

            
            
            let vue = this;



            const obj = {
                projectRevisionId: this.revisionId
            };
            
            
            this.$store.dispatch(this.$store.getters.sectionPrefix + "_getSvgFromIpc", obj)
                .then((result) => {
                    //console.log(result)
                    vue.svgViewboxAdjusted = 'notok';
                    vue.loadSVG(result);
  

                })
        },
        calculateViewbox(){
            let containerDiv = document.getElementById("svgPCB_" + this.name);
            if(!containerDiv){
                return;
            }
            let vue=this;
            //console.log('adjusted:');
            //console.log(vue.svgViewboxAdjusted);
            if(vue.svgViewboxAdjusted == "ok"){
                return;
            }
            if(null == containerDiv.offsetParent){
                //console.log('doooooooooooooooopa');
                setTimeout(vue.calculateViewbox,1000);
                return
            }
            //console.log('step0');

            let svgOnBoard = containerDiv.children[0];
            if(!svgOnBoard){
                return;
            }
            var viewerSettings = {additionalMargin:2}
            
            let acc = {};
            //console.log('step1');

            for (let el of svgOnBoard.children) {
                //console.log('step2');
                //console.log(el);
                if(el.getBBox){
                    let { x, y, width, height } = el.getBBox();
                    if (!acc.xMin || x < acc.xMin) acc.xMin = x;
                    if (!acc.xMax || x + width > acc.xMax) acc.xMax = x + width;
                    if (!acc.yMin || y < acc.yMin) acc.yMin = y;
                    if (!acc.yMax || y + height > acc.yMax) acc.yMax = y + height;
                }
            };
            if(acc.xMax==0 && acc.xMin ==0 && acc.yMax==0 && acc.yMin ==0 ){
                //console.log('doooooooooooooooopa2');
                setTimeout(vue.calculateViewbox,1000);
                return
            }
            const viewbox = `${acc.xMin-viewerSettings.additionalMargin} ${acc.yMin-viewerSettings.additionalMargin} ${acc.xMax - acc.xMin+(2*viewerSettings.additionalMargin)} ${acc.yMax - acc.yMin+(2*viewerSettings.additionalMargin)}`;

            svgOnBoard.setAttribute('viewBox', viewbox);
            vue.svgViewboxAdjusted = 'ok';
        }
        ,
        async loadSVG(blob) {
            let vue=this;
            this.svgData = await new Response(blob).text();
            let ql = document.querySelector(`#svgPCB_${this.name}`);
            ql.innerHTML = "";
            //ql.innerHTML = this.svgData;
            const hassvg = ql.querySelector("svg");

            var parser = new DOMParser();
            var doc = parser.parseFromString(this.svgData, "image/svg+xml");
            var svg = document.importNode(doc.documentElement,true)
            svg.setAttribute("width", "100%");
            svg.setAttribute("height", "100%");
            svg.setAttribute("preserveAspectRatio", "xMidYMid meet");

            if (this.zooming) {
                let instance = panzoom(ql, {
                    minZoom: 1
                });
            }

            if (ql.children.length < 7) {
                
                /*var svgOnBoard = */await ql.appendChild(svg);
                
                vue.calculateViewbox();
                
                
                
            }
            this.addEventsToParts()
        },
        selectPart(_part_reference, color) {
            
            let vue = this;
            
            let base = document.getElementById("svgPCB_" + this.name);
           
            for (const element of _part_reference) {

                if (element == undefined) {
                    return;
                }
                
                if (Array.isArray(element)) {

                    for (let el of element) {

                        let part

                        if (el.indexOf(".") > -1) {

                            part = base.querySelector(`#svg__` + el.replace(".", "\\."));
                        } else {
                            part = base.querySelector(`#svg__` + el);
                        }
                        
                        if (part != null) {
                            
                            //let part = base.querySelector(`#svg__${el}`);
                            
                            let groupPart = part.querySelector(`g`);
                            const style = window.getComputedStyle(groupPart, null);

                            // this.currentPropElement = {
                            //     stroke: style.stroke,
                            //     strokeWidth: style.strokeWidth
                            // }

                            part.style.stroke = color;
                            part.style.strokeWidth = "0.5";
                            part.style.fill = "#0f0";
                            part.style["fill-opacity"] = "0.5";
                            
                            // part.addEventListener("mouseover", function (e) {
                                
                            //     vue.tooltipObject.show = true
                            //     vue.tooltipObject.target = `#svg__${element}__copiedVariants`
                            //     vue.tooltipObject.text = element
                            // })
                            // part.addEventListener("mouseout", function (e) {
                                
                            //     vue.tooltipObject.show = false
                            //     vue.tooltipObject.target = ""
                            //     vue.tooltipObject.text = ""
                            // })


                        }

                    }


                } else {

                    let part

                    

                    if (element.indexOf(".") > -1) {

                        part = base.querySelector(`#svg__` + element.replace(".", "\\."));
                    } else {
                        part = base.querySelector(`#svg__` + element);
                    }
                    
                    if (part != null) {
                        //let part = base.querySelector(`#svg__${element}`);
                                                
                        const style = window.getComputedStyle(part, null);

                        

                        let id = part.id.split("__");
                        // this.currentPropElement = {
                        //     stroke: style.stroke,
                        //     strokeWidth: style.strokeWidth
                        // }
                        for (let i = 0, lei = this.allSelectedColors.length; i < lei; i++){
                            

                            
                            if (this.allSelectedColors[i].partReference == id[1]) {
                                color = this.allSelectedColors[i].color
                            }
                        }
                        
                        part.style.stroke = color;
                        part.style.strokeWidth = "0.5";
                        part.style.fill = color;
                        part.style["fill-opacity"] = "0.6";
                        part.classList.add("pulse");
                        
                        
                        // part.addEventListener("mouseover", function (e) {
                           
                        //     vue.tooltipObject.show = true
                        //     vue.tooltipObject.target = `#svg__${element}__copiedVariants`
                        //     vue.tooltipObject.text = element
                        // })
                        // part.addEventListener("mouseout", function (e) {
                            
                        //     vue.tooltipObject.show = false
                        //     vue.tooltipObject.target = ""
                        //     vue.tooltipObject.text = ""
                        // })

                    }
                }



            }
        },
        unSelectAllParts() {
            
            let base = document.getElementById("svgPCB_" + this.name);
            
            for (let element in this.configParts) {

                let part
                
                if (element.indexOf(".") > -1) {
                    
                    part = base.querySelector(`#svg__` + element.replace(".", "\\."));
                } else {
                    part = base.querySelector(`#svg__` + element);
                }
                                
                
                if (part != null) {
                    part.style.stroke = this.configParts[element].stroke;
                    part.style.strokeWidth = this.configParts[element].strokeWidth;
                    part.style.fill = "#0f0";
                    part.style["fill-opacity"] = "0.0";
                    part.classList.remove("pulse");
                }
                
            }
        },
        
        selectPartVariants(_allSelectedElement, color) {

            
            let vue = this;

            let base = document.getElementById("svgPCB_" + this.name);

            for (const element of _allSelectedElement) {

                if (Array.isArray(element)) {

                    for (let el of element) {

                        if (base.querySelector(`#svg__${el}`)) {

                            let partArray = base.querySelector(`#svg__${el}`);
                            let part = partArray.querySelector(`g`);

                            let svg = base.firstChild;
                            let newElem = part.cloneNode(true);


                            svg.appendChild(newElem);

                            newElem.setAttribute("id", `#svg__${element}__copiedVariants`);
                            newElem.setAttribute("class", "copiedVariants");
                            newElem.style.stroke = color;
                            
                            newElem.style["stroke-width"] = "0.3";
                            newElem.style.fill = "#000";
                            newElem.style["fill-opacity"] = "1";

                            newElem.addEventListener("mouseover", function (e) {
                                
                                vue.tooltipObject.show = true
                                vue.tooltipObject.target = `#svg__${element}__copiedVariants`
                                vue.tooltipObject.text = element
                            })
                            newElem.addEventListener("mouseout", function (e) {
                                
                                vue.tooltipObject.show = false
                                vue.tooltipObject.target = ""
                                vue.tooltipObject.text = ""
                            })
                        }

                    }


                } else {

                    if (base.querySelector(`#svg__${element}`)) {
                        let part = base.querySelector(`#svg__${element}`);
                        
                        let group = part.querySelector(`g`);
                        
                        const style = window.getComputedStyle(group, null);

                        
                        let svg = base.firstChild;
                        let newElem = part.cloneNode(true);
                        

                        svg.appendChild(newElem);

                        newElem.setAttribute("id", `#svg__${element}__copiedVariants`);
                        newElem.setAttribute("class", "copiedVariants");
                        newElem.style.stroke = color;
                        newElem.style["stroke-width"] = "0.3";
                        newElem.style.fill = "#000";
                        newElem.style["fill-opacity"]="0.1";
                        
                        newElem.addEventListener("mouseover", function (e) {
                            
                            vue.tooltipObject.show = true
                            vue.tooltipObject.target = `#svg__${element}__copiedVariants`
                            vue.tooltipObject.text = element
                        })
                        newElem.addEventListener("mouseout", function (e) {
                            
                            vue.tooltipObject.show = false
                            vue.tooltipObject.target = ""
                            vue.tooltipObject.text = ""
                        })
                    }
                }



            }
            
        },
        crossPartVariants(elementList, color) {
            
            
            for (let element of elementList) {
                
                
                let partElement = document.getElementById(`#svg__${element}__copiedVariants`)
               
                if (partElement != null) {
                    let part = partElement.querySelector(`g`);
                    const style = window.getComputedStyle(part, null);

                    

                    part.style.stroke = color;

                    var svgNS = "http://www.w3.org/2000/svg";

                    var line = document.createElementNS(svgNS, "line");

                    line.setAttributeNS(null, "x1", partElement.getBBox().x);

                    line.setAttributeNS(null, "y1", partElement.getBBox().y);
                    line.setAttributeNS(
                        null,
                        "x2",
                        partElement.getBBox().x + partElement.getBBox().width
                    );
                    line.setAttributeNS(
                        null,
                        "y2",
                        partElement.getBBox().y + partElement.getBBox().height
                    );

                    var secline = document.createElementNS(svgNS, "line");
                    secline.setAttributeNS(null, "x1", partElement.getBBox().x);
                    secline.setAttributeNS(
                        null,
                        "y1",
                        partElement.getBBox().y + partElement.getBBox().height
                    );
                    secline.setAttributeNS(
                        null,
                        "x2",
                        partElement.getBBox().x + partElement.getBBox().width
                    );
                    secline.setAttributeNS(null, "y2", partElement.getBBox().y);
                    secline.setAttributeNS(null, "stroke", "diff");
                    secline.setAttributeNS(null, "stroke-width", "0.1");
                    

                    line.setAttributeNS(null, "stroke", color);
                    line.setAttributeNS(null, "stroke-width", "0.1");



                    var crossGroup = document.createElementNS(svgNS, "g");
                    //crossGroup.style.width= "70%";
                    crossGroup.id = "CrossElement_" + element;

                    crossGroup.appendChild(line);
                    crossGroup.appendChild(secline);
                    var x = part.getBBox().x / 4;
                    var y = part.getBBox().y / 4;

                    //part.appendChild(crossGroup);
                }
            }
        },
        
        resetAllVariants() {
            
            let copied = document.getElementsByClassName("copiedVariants");

            while (copied.length > 0) {

                copied[copied.length - 1].remove();
            }
            let s = document.getElementsByClassName("copiedVariants");
            
        }
    },
    
};
</script>

<style lang="scss">
.IpcViewerComponent {
    display: block;
    overflow: hidden;

    //padding: 10px 0 10px 0;
    .svgContainer {
        background-color: #000;
        display: block;
        overflow: hidden;
        width: 100%;
        height: 100%;
    }

    .svgPCB {
        background-color: #000;
        display: block;
        width: 100%;
        overflow: hidden;
    }
    .element-layers{
        
        .list-group-item{
            margin-top: 0px;
        }
        .layers-checkboxes{
            margin-top: 10px;
        }
    }
    .pulse {
        fill: rgba(#0f0, .5);
        animation: pulse2 1.5s ease-in-out;
        
    }
    @keyframes pulse2 {
        0% {
            
            opacity: 0;
        }

        50% {
            opacity: 1;
        }

        100% {
            
            opacity: 0;
        }
        0% {
            
            opacity: 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/IpcViewerComponent.vue